exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".no-padding {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.small-right {\n  padding-right: 2px;\n  padding-left: 2px;\n}\n\n.small-left {\n  padding-right: 2px;\n  padding-left: 2px;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/components/StepPage/StepPage.css
 ** module id = 429
 ** module chunks = 0
 **/